import { NavLink } from "react-router-dom";
import { LayoutDashboard, Users, Clock, Plus, LogOut, X, FileCheck2, Cpu } from "lucide-react";
import { useAppData } from "../data/AppDataContext";
import { useAuth } from "../auth/AuthContext";

export default function Sidebar({ isOpen, onClose }) {
  const { pendingPayments } = useAppData();
  const { user, logout } = useAuth();
  const role = user?.role || "admin";
  const canSeeDashboard = role === "admin";
  const canSeeQueue = role === "admin";
  const canSeeCompleted = role === "admin";
  const canSeePlans = role === "admin" || role === "manager";
  const canSeeNewPlan = role === "admin" || role === "team_lead";

  return (
    <>
      {isOpen && <div className="pl-sidebar-backdrop" onClick={onClose} />}
      <nav className={`pl-sidebar${isOpen ? " open" : ""}`}>
        <div className="pl-brand">
          <img src="/oticLogo.png" alt="Otic" style={{ width: 24, height: 24, objectFit: "contain", borderRadius: 6 }} />
          Plan Ledger
          <button className="pl-sidebar-close" onClick={onClose} aria-label="Close menu">
            <X size={18} />
          </button>
        </div>

        <div style={{ fontSize: 10.5, fontWeight: 700, color: "#7a8bbf", letterSpacing: "0.06em", textTransform: "uppercase", padding: "0 14px", marginBottom: 8 }}>
          Main
        </div>

        {canSeeDashboard && (
          <NavLink to="/" end className={({ isActive }) => `pl-nav-link${isActive ? " active" : ""}`} onClick={onClose}>
            <LayoutDashboard size={18} strokeWidth={2} /> Dashboard
          </NavLink>
        )}

        <NavLink to="/customers" className={({ isActive }) => `pl-nav-link${isActive ? " active" : ""}`} onClick={onClose}>
          <Users size={18} strokeWidth={2} /> Customers
        </NavLink>

        {canSeeQueue && (
          <NavLink to="/queue" className={({ isActive }) => `pl-nav-link${isActive ? " active" : ""}`} onClick={onClose}>
            <Clock size={18} strokeWidth={2} /> Pending queue
            {pendingPayments.length > 0 && <span className="pl-nav-badge">{pendingPayments.length}</span>}
          </NavLink>
        )}

        {canSeeCompleted && (
          <NavLink to="/completed-payments" className={({ isActive }) => `pl-nav-link${isActive ? " active" : ""}`} onClick={onClose}>
            <FileCheck2 size={18} strokeWidth={2} /> Completed Payments
          </NavLink>
        )}

        {canSeePlans && (
          <NavLink to="/plans" className={({ isActive }) => `pl-nav-link${isActive ? " active" : ""}`} onClick={onClose}>
            <Cpu size={18} strokeWidth={2} /> Plan Management
          </NavLink>
        )}

        {canSeeNewPlan && (
          <NavLink to="/new-plan" className={({ isActive }) => `pl-nav-link${isActive ? " active" : ""}`} onClick={onClose}>
            <Plus size={18} strokeWidth={2} /> New plan
          </NavLink>
        )}

        <div style={{ marginTop: "auto", paddingTop: 16, borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          {user && (
            <div style={{ fontSize: 12, color: "#aebde3", padding: "0 14px 10px" }}>
              Signed in as <strong style={{ color: "#fff" }}>{user.username}</strong>
            </div>
          )}
          <button onClick={logout} className="pl-nav-link" style={{ width: "100%", border: "none", background: "transparent", cursor: "pointer" }}>
            <LogOut size={18} strokeWidth={2} /> Log out
          </button>
        </div>
      </nav>
    </>
  );
}